import { render, staticRenderFns } from "./CostTablePerProject.vue?vue&type=template&id=87e60e40&"
import script from "./CostTablePerProject.vue?vue&type=script&lang=js&"
export * from "./CostTablePerProject.vue?vue&type=script&lang=js&"
import style0 from "./CostTablePerProject.vue?vue&type=style&index=0&id=87e60e40&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87e60e40')) {
      api.createRecord('87e60e40', component.options)
    } else {
      api.reload('87e60e40', component.options)
    }
    module.hot.accept("./CostTablePerProject.vue?vue&type=template&id=87e60e40&", function () {
      api.rerender('87e60e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectmanagement/CostTablePerProject.vue"
export default component.exports